module.exports = __webpack_public_path__ + "img/logo2.c9275a8e.png";